import React from 'react';
import styled from 'styled-components';
import { computeDaysLeft, formatDemoBannerText } from '../utils/demoBanner';
import { useTranslation } from '../translations';

const Banner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--sp-2);
  padding: var(--sp-3) var(--sp-4);
  margin-bottom: var(--sp-4);
  border-radius: var(--r-sm);
  font-size: var(--fs-sm);
  font-weight: 600;
  /* Kolory znaczeniowe z index.css: baner byl wpisany na sztywno w jasnym brazie na
     jasnozoltym tle, wiec w trybie ciemnym byl jasna plama nad ciemnym panelem. */
  color: var(--warning);
  background: var(--warning-bg);
  border: 1px solid var(--warning-border);
`;

const TourButton = styled.button`
  padding: var(--sp-1) var(--sp-3);
  border-radius: var(--r-sm);
  border: 1px solid var(--warning-border);
  background: var(--card-bg);
  color: var(--warning);
  font-size: var(--fs-sm);
  font-weight: 700;
  cursor: pointer;

  &:hover { background: var(--hover-bg); }
`;

export default function DemoBanner({ user, onShowTour }) {
  const { t } = useTranslation();

  if (!user?.isDemo) return null;

  const daysLeft = computeDaysLeft(user.accessExpiresAt);
  const text = formatDemoBannerText(daysLeft);
  if (!text) return null;

  return (
    <Banner role="status" data-tour="demo-banner">
      {text}
      {onShowTour && (
        <TourButton type="button" onClick={onShowTour} data-cy="demo-tour-open">
          {t('common.tour')}
        </TourButton>
      )}
    </Banner>
  );
}
